import { Component, h, Prop, State } from "@stencil/core";
import { getBackTeaserData } from "./persist";

/**
 * This component displays a back button and a text.
 * The back button navigates back to the page that was saved previously by the ux-iws-back-teaser-save component.
 */
@Component({
    tag: "ux-iws-back-teaser",
    styleUrl: "back-teaser.scss",
    shadow: false,
})
export class BackTeaser {
    /** intro text for the teaser */
    @Prop({
        reflect: true,
    })
    intro: string = "";
    /** text that will be placed before the title of the link */
    @Prop({
        reflect: true,
    })
    text: string = "";

    @State() href: string = null;
    @State() title: string = null;

    componentWillLoad() {
        const backTeaserData = getBackTeaserData();
        if (backTeaserData !== null) {
            this.href = backTeaserData.href;
            this.title = backTeaserData.title;
        }
    }

    render() {
        if (this.href === null || this.title === null) {
            return null;
        }
        return (
            <ux-iws-link-wrapper class="ux-u-shadow ux-u-mx-xs">
                <div class="ux-u-d-flex ux-u-p-xs">
                    <a href={this.href} class="ux-button ux-button--icon-only">
                        <ux-icon name="chevron-left" weight="normal"></ux-icon>
                    </a>
                    <div class="ux-u-mx-xs">
                        <div class="ux-text-tiny ux-u-text-uppercase ux-u-mb-xxxs">
                            {this.intro}
                        </div>
                        <div class="ux-text-normal">
                            {this.text} "{this.title}".
                        </div>
                    </div>
                </div>
            </ux-iws-link-wrapper>
        );
    }
}
